// Protected Route Component
import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { authService } from '../services/authService';
import FloatingAIButton from '../components/FloatingAIButton';
import { AnalyticsChatProvider } from '../modules/analytics-copilot/context/AnalyticsChatContext';
import { useIdleLogout } from '../shared/hooks/useIdleLogout';

interface ProtectedRouteProps {
  redirectPath?: string;
}

/** Mounted only when authenticated — 20-min inactivity auto-logout (audit #3). */
const IdleLogoutGuard: React.FC = () => {
  useIdleLogout();
  return null;
};

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  redirectPath = '/',
}) => {
  const location = useLocation();
  const isAuthenticated = authService.isAuthenticated();

  if (!isAuthenticated) {
    // Save the attempted URL so we can redirect after login
    return <Navigate to={redirectPath} state={{ from: location }} replace />;
  }

  return (
    <AnalyticsChatProvider>
      <IdleLogoutGuard />
      <Outlet />
      <FloatingAIButton />
    </AnalyticsChatProvider>
  );
};

export default ProtectedRoute;
